import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=310bcb40&"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports